import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import React, { useEffect, useState } from "react";
import '../../../../cssfiles/homepage.css';
import { useSelector } from 'react-redux';
import { getalltags } from '../../../../Restclient/datacollection';



function ParameterListTable(props) {
    // Redux selectors
    const livedata = useSelector(state => state.mainpagedata.livedata);    

    // State variables
    const [tableHead, setTableHead] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [tags, setTags] = useState([]);

    const columnCategories = props.widgetprop.props.extended.column_categories;
    

    useEffect(() => {
        getalltags(props.widgetprop.props.extended.tagprops[0].deviceId,callback)
    }, [props.widgetprop])

    function callback(res){
        setTags([...res])
    }

    useEffect(() => {
        const rowsValues = [];
        for (const tag of tags) {
            if(tag && tag!==null && tag!==undefined){
                const parameterName = tag.parameter;
                const parameterUnit = tag.unit;
                rowsValues.push([parameterName, '', parameterUnit, '']);
                if (livedata.length) {
                    for (const liveDataItem of livedata) {
                        if (parseInt(tag.tagId, 10) === parseInt(liveDataItem.TagId, 10)) {
                            rowsValues[rowsValues.length -1][1] = liveDataItem.value.toFixed(3);
                            const date = new Date(liveDataItem.timestamp * 1000);
                            rowsValues[rowsValues.length -1][3] = `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()} ${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
                        }
                    }
                }
            }
        }
            setTableHead(columnCategories);
            setTableRows(rowsValues);
    }, [tags, livedata]);
    

          return(
            <>
            {tableRows.length > 0 && (
                <TableContainer
                    component={Paper}
                    sx={{
                        width: "100%",
                        height: "100%",
                        paddingLeft: "0px",
                        backgroundColor: "var(--secondary-backgroundLK)",
                        paddingRight: "0px",
                    }}
                    elevation={0}
                >
                    <Table sx={{ width: "100%" }} size="small">
                        <TableHead>
                            <TableRow sx={{ border: "0px" }}>
                                {tableHead.map((tableHeadValue, index) => (
                                    <TableCell
                                        key={index}
                                        sx={{
                                            fontSize: props.widgetprop.props.extended.tablehead.fontsize,
                                            fontWeight: props.widgetprop.props.extended.tablehead.fontweight,
                                            color: "var(--grey-variation-tableLK)",
                                            width: index === 0 ? "40%" : "auto", // Example: Set the first column to 25% width
                                        }}
                                    >
                                        {tableHeadValue}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableRows.map((row, rowIndex) => (
                                <TableRow
                                    key={rowIndex}
                                    sx={{
                                        "&:last-child td, &:last-child th": { border: 0 },
                                        height: "9px",
                                        "& > *": { borderBottom: "1px solid var(--table-boarder-line)" },
                                    }}
                                >
                                    {row.map((rowValue, cellIndex) => (
                                        <TableCell
                                            key={cellIndex}
                                            component="th"
                                            scope="row"
                                            sx={{
                                                fontSize: props.widgetprop.props.extended.tablerows.fontsize,
                                                fontWeight: props.widgetprop.props.extended.tablerows.fontweight,
                                                color:
                                                    rowValue === "Connected" || rowValue === "ON TARGET"
                                                        ? "#00943D"
                                                        : rowValue === "Disconnected" || rowValue === "DEVIATED BY 3%"
                                                        ? "#DC272D"
                                                        : "var(--grey-variation-tablerowsLK)",
                                            }}
                                        >
                                            {rowValue}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </>
        )
    
}

export default ParameterListTable;
